import { Input, Spin } from 'antd';
import { MainCard } from 'ui/components/main-card';
import { useTranslation } from 'translations/hooks';

import { useReceiptScanner } from './hooks/use-receipt-scanner';
import { QuarantineDrawer } from './components/quarantine-drawer';
import { ContentHeader } from 'ui/components/content-header';
import { AlertDrawer } from 'ui/components/alert-drawer';
import { ScanSquare } from 'ui/components/scan-square';
import { useEffect } from 'react';

export const ReceiptPage = () => {
  const { t } = useTranslation();
  const {
    inputRef,
    inputValue,
    handleInputChange,
    handleKeyDown,
    isLoading,
    drawerIsOpen,
    setDrawerIsOpen,
    quarantineDrawerIsOpen,
    setQuarantineDrawerIsOpen,
    quarantineRedirection,
    repairRedirection,
    rejectRedirection,
    resetAndFocus,
    isQuarantineEnabled,
  } = useReceiptScanner();

  useEffect(() => {
    if (!drawerIsOpen && !quarantineDrawerIsOpen && !isLoading) {
      resetAndFocus();
    }
  }, [drawerIsOpen, quarantineDrawerIsOpen, isLoading, resetAndFocus]);

  return (
    <ContentHeader title={t('receipt.title')} className="w-full px-4 py-8">
      <MainCard>
        <ScanSquare>
          <Input
            placeholder={t('receipt.placeholder')}
            size="large"
            ref={inputRef}
            value={inputValue}
            autoFocus
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            disabled={isLoading}
          />
          <div className="flex justify-center pt-4">
            {isLoading ? <Spin size="small" /> : null}
          </div>
        </ScanSquare>
      </MainCard>

      <AlertDrawer
        message={t('receipt.segmentAlreadyInstalled')}
        isOpen={drawerIsOpen}
        setIsOpen={setDrawerIsOpen}
      />
      <QuarantineDrawer
        quarantineRedirection={quarantineRedirection}
        repairRedirection={repairRedirection}
        rejectRedirection={rejectRedirection}
        isOpen={quarantineDrawerIsOpen}
        onClose={() => {
          setQuarantineDrawerIsOpen(false);
          resetAndFocus();
        }}
        isQuarantineEnabled={isQuarantineEnabled}
      />
    </ContentHeader>
  );
};
